import React from 'react'
import {
    Box,
    Stack
} from '@mui/material'
import * as Images from '../../components/UIComponents/Images'
import * as Buttons from '../../components/UIComponents/Button'
import * as Texts from '../../components/UIComponents/Text'

const { innerWidth } = window

const FAQBotOnboarding = ({
    onClick
}) => {
    return (

        <Stack
            direction="column"
            justifyContent={"center"}
            spacing={3}
            sx={{
                px: 6,
                maxWidth: innerWidth
            }}
        >
            <Box>
                <Images.ChatbotOnboarding />
            </Box>
            <Stack
                direction="column"
                spacing={2}
            >
                <Box>
                    <Texts.H4>Question about your visit?</Texts.H4>
                </Box>
                <Box>
                    <Texts.Paragraph>Let us help you!</Texts.Paragraph>
                </Box>
            </Stack>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center'
                }}
            >
                <Buttons.Button
                    onClick={onClick}
                >
                    <Texts.H4 sx={{ color: "primary.contrastText" }}>FAQ相談</Texts.H4>
                </Buttons.Button>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center'
                }}
            >
                <Texts.Paragraph>What is FAQoid?</Texts.Paragraph>
            </Box>
        </Stack>
    )

}
export default FAQBotOnboarding